import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageManagementService } from 'src/service/language-management.service';
import { BulkLogDetailsInitialization, KeyValueSet, LocalService } from 'src/service/local.service';
import { RequestManagementService } from 'src/service/request-management.service';

@Component({
  selector: 'app-request-log-details',
  templateUrl: './request-log-details.component.html',
  styleUrls: ['./request-log-details.component.scss']
})
export class RequestLogDetailsComponent {
  lstSectionConfigKeys: string[] = ["bulk_log"];
  ctryCode: string = ''; interactionType = 0; userId: string = '';
  logId: string = ''; source: BulkLogDetailsInitialization;
  iCurrentRow = 1; iTotalCount = 0; selectedLogStatus = '0';
  maxBodyHeight = 0;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private requestManagementService: RequestManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.logId = routeParams.logId;
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.requestManagementService.getBulkLogDetailsInitialization(this.logId, this.ctryCode).subscribe(result => {
      this.source = result;
      this.onSetTotalCount();
    });
  }

  onSetTotalCount() {
    this.iTotalCount = parseInt(this.source.statusSummary.find(x => x.key == this.selectedLogStatus).value);
  }

  onGetText(index, key) {
    let item: KeyValueSet;
    let differenceText = '';
    switch (index) {
      case 1: {
        item = this.source.columnKeys.find(x => x.key == key);
      } break;
      case 2: {
        item = this.source.logStatus.find(x => x.key == key);
      } break;
      case 3: {
        item = this.source.logReason.find(x => x.key == key);
      } break;
    }
    return (item ? item.value : '-') + (differenceText != '' ? " (" + differenceText + ") " : '');
  }

  onStatusSelect() {
    this.iCurrentRow = 1;
    this.onSetTotalCount();
    this.onGetLogDetail();
  }

  onGetLogDetail(index = 0) {
    switch (index) {
      case 1: {
        this.iCurrentRow = this.iCurrentRow - 1;
      } break;
      case 2: {
        this.iCurrentRow = this.iCurrentRow + 1;
      } break;
    }
    this.requestManagementService.getBulkLogDetails(this.logId, this.iCurrentRow, parseInt(this.selectedLogStatus), this.ctryCode).subscribe(result => {
      this.source.details = result;
    });
  }
}
